<template>
  <div class="JurisdictionAuth">
    <div class="flex-content">
      <div class="flex-title">
        <h3>权限对象:</h3>
        <div class="flex-button">
          <div v-if="hideEditButton && editStatus">
            <Button style="margin-right: 10px;" @click="goBatch">批量修改</Button>
            <Button type="primary" @click="revise">修改</Button>
          </div>
          <div v-if="!editStatus">
            <Button @click="handleBack" type="default" size="default" style="margin-right: 10px;">取消</Button>
            <Button @click="handleSaveButton" type="primary" size="default" :loading="loading">保存</Button>
          </div>
        </div>
      </div>
      <div class="departmentStaff">
        <h3>{{userName}}</h3>
      </div>
      <div class="flex-title">
        <h3>员工权限设置:</h3>
      </div>
      <div class="departmentStaff">
        <div :class="['e-checkbox-group', { editStatus: !editStatus }]">
          <div
              v-for="(item,index) in floor"
              v-bind:key="index"
              :class="['e-checkbox', { active: item.isChecked }]"
              v-on:click="handleClick(item, index)"
          >
            <Checkbox v-model="item.isChecked" :disabled="editStatus"></Checkbox>
            {{item.officePermName}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIdInSession } from '@/libs/util';
  export default {
    name: 'JurisdictionAuth',
    components: {
    },
    data () {
      return {
        editStatus: true,
        hideEditButton: true,
        userName: '',
        floor: [],
        loading: false
      }
    },
    mounted () {
      this.initialData();
    },
    watch: {
      '$route': 'initialData'
    },
    methods: {
      initialData () {
        let id = this.$route.query.id;
        if (id === undefined) {
          id = sessionStorage.getItem('id');
        }
        this.$get(`/company/userOfficePermLimit?userId=${id}`).then(res => {
          if (res.success) {
            console.log(res)
            this.userName = res.data.userName
            this.floor = res.data.userOfficePermLimits
          }
        })
      },
      // 修改
      revise () {
        this.editStatus = false
        this.hideEditButton = false
      },
      // 取消
      handleBack () {
        this.editStatus = true
        this.hideEditButton = true
      },
      // 保存
      handleSaveButton () {
        this.loading = true
        let option = {
          inUserIds: [],
          outUserIds: [],
          userId: this.$route.query.id || getIdInSession(),
          officePermType: this.floor.filter(item => !item.isChecked).map(i => i.officePermType)
        }
        this.$post(`/company/saveOneUserOfficePerm`, option).then(res => {
          if (res.success) {
            this.loading = false
            this.editStatus = true
            this.hideEditButton = true
            this.initialData()
          } else {
            this.loading = false
          }
        })
      },
      handleClick (item, index) {
        if (!this.editStatus) { // 只有在编辑状态才可以点击
          this.floor[index].isChecked = !item.isChecked
        }
      },
      goBatch () {
        let that = this;
        console.log(that.floor)
        this.$router.push({
          name: 'JurisdictionBatch',
          query: {
            list: JSON.stringify(that.floor)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../../index.less";
  .JurisdictionAuth{
    width: 80%;
    padding: 20px;
    .flex-content {
      margin: 10px 0;
      .flex-title{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        h3{
          font-size: 16px;
        }
      }
      .departmentStaff{
        padding: 15px 0 15px 30px;
        h3{
          font-size: 17px;
          color: #1A60A6;
          span{
            margin: 0 8px;
          }
        }
        .e-checkbox-group{
          width: 60%;
          display: flex;
          flex-direction: column;
          margin: 20px 0;
          .e-checkbox{
            display: inline-block;
            padding: 12px 10px;
            cursor: pointer;
            font-size: 14px;
            margin-bottom: 5px;
            border: 1px solid @light-font-color;
            &.active{
              border: 1px solid @active-border-color;
              color: @active-font-color;
            }
          }
          &.editStatus{
            .e-checkbox{
              border: 1px solid @active-font-color;
              color: @active-font-color;
              &.active{
                color: @active-color;
                border-color: @active-color;
              }
            }
          }
        }
      }
    }
  }
</style>
